/* eslint-disable max-len */
const React = require('react');

const PluginLojaIntegrada = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="49" viewBox="0 0 54 49">
    <g fill="none">
      <path fill="#F16339" d="M30.478 24.058c-.073 1.347-.786 2.578-1.918 3.312l-10.51 5.974c-1.06.603-1.926.098-1.926-1.118v-12.46c.075-1.35.79-2.581 1.926-3.314l10.51-5.973c1.06-.604 1.926-.098 1.926 1.118l-.008 12.46z" transform="translate(11.5 8.306)" />
      <path fill="#9CCB3C" d="M14.362 19.765c-.075-1.349-.79-2.58-1.926-3.313L1.926 10.48C.865 9.875 0 10.381 0 11.605v12.453c.077 1.346.793 2.574 1.926 3.304l10.51 5.973c1.06.604 1.926.098 1.926-1.117V19.765z" transform="translate(11.5 8.306)" />
      <path fill="#44C1C4" d="M17.25.45c-1.216-.6-2.643-.6-3.86 0L2.759 6.539c-1.06.604-1.053 1.583 0 2.17l10.461 5.794c1.22.596 2.648.596 3.868 0L27.695 8.48c1.06-.596 1.06-1.575 0-2.17L17.25.45z" transform="translate(11.5 8.306)" />
    </g>
  </svg>
);

module.exports = PluginLojaIntegrada;
